import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class ViewHeader {
  @bindable private badgeClass: string;
  constructor() {}
}
